import walletFinancialPositionsMessages from '../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../column';
import { ManagedProduct } from '../managed-macro-category';

export const assetManagementColumns: Column<ManagedProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderContract,
    key: 'newContractCode',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderDate,
    key: 'date',
    type: 'date',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValue,
    key: 'equivalent',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderGainEuros,
    key: 'gainEur',
    type: 'amount',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderGainPercentage,
    key: 'gainPercentage',
    type: 'percentage',
  },
];
